import React, { useEffect, useState } from "react";
const ChangeLogCard: React.FC = () => {
  const [data, setData] = useState("");

  useEffect(() => {
    fetch("/changelog.md")
      .then((res) => res.text())
      .then((text) => setData(text));
  }, []);

  return (
    <div className="middle-card">
      <h4 className="card-title">Notas de Atualização</h4>
      <div className="mt-4 flex h-full w-full flex-col overflow-y-scroll rounded-lg bg-zinc-100 p-2 dark:bg-transparent">
        <p className="whitespace-pre-wrap text-xs text-zinc-700 dark:text-zinc-400">
          {data}
        </p>
      </div>
    </div>
  );
};

export default ChangeLogCard;
